import { Component } from 'react'
import ReactDOM from 'react-dom'

class Portal extends Component {
  el = document.createElement('div');
  portal = document.getElementById('portals');

  componentDidMount() {
    this.portal.appendChild(this.el)
  }

  componentWillUnmount() {
    this.portal.removeChild(this.el)
  }

  render() {
    const { children } = this.props

    return ReactDOM.createPortal(children, this.el)
  }
}

export default Portal
